<template>
  <v-breadcrumbs class="manage-bread-crumb__breadcrumb" :items="breadcrumbItems" large dark>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item :to="item.to" active-class="none">
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
import updatePageTitle from '@/config/updatePageTitle';
import { createNamespacedHelpers } from 'vuex';
import replaceDelayedValue from '@/config/replaceDelayedValue.js';

const { mapGetters: mapCoursesGetters } = createNamespacedHelpers('courses');
const { mapGetters: mapGroupsGetters } = createNamespacedHelpers('groups');

export default {
  computed: {
    ...mapCoursesGetters({
      course: 'breadcrumbCourse'
    }),
    ...mapGroupsGetters({
      group: 'breadcrumbGroup'
    }),
    breadcrumbItems() {
      return (
        this.$route.meta.breadcrumbs &&
        this.$route.meta.breadcrumbs.map(breadcrumb => ({
          ...breadcrumb,
          text: replaceDelayedValue(
            replaceDelayedValue(breadcrumb.text, '{course}', this.course),
            '{group}',
            this.group
          )
        }))
      );
    },
    updatedTitle() {
      const title = replaceDelayedValue(this.$route.meta.title, '{course}', this.course).replace('{group}', this.group);
      return updatePageTitle(title);
    }
  },
  watch: {
    updatedTitle(title) {
      document.title = title;
    }
  },
  mounted() {
    document.title = this.updatedTitle;
  }
};
</script>

<style lang="scss">
.manage-bread-crumb__breadcrumb {
  a {
    color: white !important;
    text-decoration: none;
  }
}
</style>
